var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page container"},[_c('div',[_c('activity',{attrs:{"lessonId":_vm.getLessonId,"type":_vm.getType,"activityId":_vm.getActivityId,"cancelRoute":_vm.getActivityRoute,"successRoute":_vm.getActivityRoute}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }